import { getShowtimeById } from '@vista/omnichannel-components-domain';
import { OrderShowtimeSeatSwapUnavailableReason } from '@vista-digital/ocapi-types/v1';
import { isPast } from 'date-fns';
export var SwapSeatUnavailableReason;
(function (SwapSeatUnavailableReason) {
    SwapSeatUnavailableReason["FailedToLoadData"] = "FailedToLoadData";
    SwapSeatUnavailableReason["OrderIncludesInSeatDeliveryItems"] = "OrderIncludesInSeatDeliveryItems";
    SwapSeatUnavailableReason["OrderIncludesPackageTickets"] = "OrderIncludesPackageTickets";
    SwapSeatUnavailableReason["Other"] = "Other";
    SwapSeatUnavailableReason["ShowtimeEnded"] = "ShowtimeEnded";
    SwapSeatUnavailableReason["ShowtimeSoldOut"] = "ShowtimeSoldOut";
})(SwapSeatUnavailableReason || (SwapSeatUnavailableReason = {}));
export const getSwapSeatAvailabilityStatus = (orderShowtime) => {
    const showtime = getShowtimeById(orderShowtime.showtimeId);
    if (!showtime)
        return { isAvailable: false, unavailableReason: SwapSeatUnavailableReason.FailedToLoadData };
    if (showtime.isSoldOut)
        return { isAvailable: false, unavailableReason: SwapSeatUnavailableReason.ShowtimeSoldOut };
    if (isPast(new Date(showtime.schedule.endsAt))) {
        return { isAvailable: false, unavailableReason: SwapSeatUnavailableReason.ShowtimeEnded };
    }
    const { isAvailable, unavailableReason } = orderShowtime.seatSwapStatus;
    if (isAvailable)
        return { isAvailable: true };
    switch (unavailableReason) {
        case OrderShowtimeSeatSwapUnavailableReason.PackageTickets:
            return { isAvailable: false, unavailableReason: SwapSeatUnavailableReason.OrderIncludesPackageTickets };
        case OrderShowtimeSeatSwapUnavailableReason.InSeatDeliveryItems:
            return {
                isAvailable: false,
                unavailableReason: SwapSeatUnavailableReason.OrderIncludesInSeatDeliveryItems
            };
        default:
            return { isAvailable: false, unavailableReason: SwapSeatUnavailableReason.Other };
    }
};
